const playerColors = {
	x : '#3e89cf',
	o : '#39bdd7'
};

export default playerColors;
